import { SET_RECOMMENDATIONS, REMOVE_RECOMMENDATIONS, ADD_RECOMMENDATION, EDIT_RECOMMENDATION } from './types'

export function setRecommendations (recommendations = []) {
  return {
    type: SET_RECOMMENDATIONS,
    payload: recommendations
  }
}

export function editRecommendation (id, data) {
  return {
    type: EDIT_RECOMMENDATION,
    payload: {
      id,
      data
    }
  }
}

export function addRecommendation (recommendation) {
  return {
    type: ADD_RECOMMENDATION,
    payload: recommendation
  }
}

export function removeRecommendations () {
  return {
    type: REMOVE_RECOMMENDATIONS
  }
}
